<template>
  <div :class="$style.container">
    <Card>
      <Form :model="cityInfo" :label-width="80" style="padding-bottom: 10px;">
        <Row style="margin-top:20px;">
          <Col span="5">
          <FormItem label="选择省份">
            <Select v-model="province">
              <Option :value="JSON.stringify(item)" v-for="item in cityInfo.provinceOption" :key="item.iregionalid">{{item.szregionalname}}</Option>
            </Select>
          </FormItem>
          </Col>
          <Col span="5">
          <FormItem label="选择城市" style="margin:0 20px;">
            <Select v-model="city">
              <Option :value="JSON.stringify(item)" v-for="item in cityInfo.cityOption" :key="item.iregionalid">{{item.szregionalname}}</Option>
            </Select>
          </FormItem>
          </Col>
          <Col span="5">
          <FormItem label="选择区域" style="margin-right: 10px;">
            <Select v-model="region">
              <Option :value="JSON.stringify(item)" v-for="item in cityInfo.regionOption" :key="item.iregionalid">{{item.szregionalname}}</Option>
            </Select>
          </FormItem>
          </Col>
          <Col span="5">
          <FormItem :label-width="10">
            <Button type="primary" @click="handleSubmitCity" :disabled="isDisabled">确定</Button>
            <Button  @click="handleHomeClcick" style="margin-left:20px;">返回首页</Button>
          </FormItem>
          </Col>
        </Row>
      </Form>
      <CityList/>
    </Card>

  </div>
</template>
<script>
import CityList from './componnets/list'
export default {
  data() {
    return {
      cityInfo: {
        provinceOption: [],
        cityOption: [],
        regionOption: []
      },
      province: "",
      city: "",
      region: ""
    };
  },
  components: {
    CityList
  },
  computed: {
    isDisabled() {
      if (this.province) {
        return false;
      }
      return true;
    }
  },
  watch: {
    province(val) {
      if (val) {
        let code = JSON.parse(val) ? JSON.parse(val).iregionalid : "";
        if (code) {
          this.getRegionList(code);
        }
      }
    },
    city(val) {
      if (val) {
        let code = JSON.parse(val) ? JSON.parse(val).iregionalid : "";
        if (code) {
          this.getRegionList(code);
        }
      }
    }
  },
  mounted() {
    this.getRegionList();
  },
  methods: {
    // 获取城市列表(切换城市)
    async getRegionList(code = 1) {
      try {
        let res = await this.$api.get2(
          this.lee + `/sys/sourceRegion/v1/getSourceRegionList`,
          {
            iregionalid: code
          }
        );
        if (res.code === 200) {
          let level = res.data[0].ilevel;
          if (level === 2) {
            this.cityInfo.provinceOption = res.data;
            this.province = "";
            this.city = "";
            this.region = "";
            this.cityInfo.cityOption = [];
            this.cityInfo.regionOption = [];
          } else if (level === 3) {
            this.cityInfo.cityOption = res.data;
            this.city = "";
            this.region = "";
            this.cityInfo.regionOption = [];
          } else if (level === 4) {
            this.cityInfo.regionOption = res.data;
            this.region = "";
          }
        }
      } catch (err) {
        console.log("1111", err);
      }
    },
    // 切换城市
    handleSubmitCity() {
      let url = "";
      let curentCity = "";
      if (this.province) {
        url = JSON.parse(this.province).domainurl;
        curentCity = JSON.parse(this.province).szregionalname;
      }
      if (this.city) {
        url = JSON.parse(this.city).domainurl;
        curentCity = JSON.parse(this.province).szregionalname;
      }
      if (this.region) {
        url = JSON.parse(this.region).domainurl;
        curentCity = JSON.parse(this.province).szregionalname;
      }

      if (!url) {
        this.$Modal.error({
          title: "提示",
          content: "未开通此区域"
        });
        setTimeout(() => {
          this.province = "";
          this.city = "";
          this.region = "";
          this.cityInfo.cityOption = [];
          this.cityInfo.regionOption = [];
        }, 30);
        return false;
      }
      this.curentCity = curentCity;
      window.location.href = url;
    },
    // 返回首页
    handleHomeClcick () {
      this.$router.push({
        path: '/index_home'
      })
    }
  }
};
</script> 
<style lang="less" module>
.container {
  padding: 20px 100px;
}
</style>